module.exports = __webpack_public_path__ + "img/about.e0dc1f03.gif";